module.exports = __webpack_public_path__ + "img/003-bed.d9b939fe.svg";